var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "lukk",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.310084 0.310084C0.723529 -0.10336 1.39385 -0.103362 1.8073 0.310083L5.73856 4.24135C5.88295 4.38573 6.11705 4.38573 6.26144 4.24135L10.1927 0.310084C10.6061 -0.103361 11.2765 -0.103361 11.6899 0.310084C12.1034 0.723529 12.1034 1.39385 11.6899 1.8073L7.75865 5.73856C7.61427 5.88295 7.61427 6.11705 7.75865 6.26144L11.6899 10.1927C12.1034 10.6061 12.1034 11.2765 11.6899 11.6899C11.2765 12.1034 10.6061 12.1034 10.1927 11.6899L6.26144 7.75865C6.11705 7.61427 5.88295 7.61427 5.73856 7.75865L1.8073 11.6899C1.39386 12.1034 0.723529 12.1034 0.310084 11.6899C-0.10336 11.2765 -0.103362 10.6061 0.310083 10.1927L4.24135 6.26144C4.38573 6.11705 4.38573 5.88295 4.24135 5.73856L0.310084 1.8073C-0.103361 1.39386 -0.103361 0.723529 0.310084 0.310084Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.defaa4f4.svg";
export { ForwardRef as ReactComponent };